import moment from "moment";
import Action from "./Action";
import BuildingName from "./BuildingName";
import MailerProgram from "./MailerProgram";
import Green from "../../../../../styles/svg/compliance-green.svg";
import { addLeadCompliance } from "../../../../../sevices/leadComplianceApi";
import { addFireNotice } from "../../../../../sevices/fireNoticeApi";
import HPDalerts from "../Units/HPDalerts";
import { isAdmin } from "../../../../../utils/helpers";
import { addLL55Compliance } from "../../../../../sevices/ll55Api";

  export const columns = [
    {
      field: "address",
      headerName: "Building",
      renderCell: (params) => {
        return <BuildingName params={params} />;
      },
      minWidth: 140,
      flex: 1,
      // editable: true,
      sortable: true,
    },
    {
      field: "units",
      headerName: "#Units",
      renderCell: (params) => {
        return (
          <p className="w-100 d-flex justify-content-center">
            {params?.value.length}
          </p>
        );
      },
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p>#Units</p>
        </div>
      ),
      minWidth: 140,
      flex: 1,
      // editable: true,
      headerClassName: "center-header",
    },
    {
      field: "mailer_program",
      headerName: "Mailer Program",
      renderCell: (params) => {
        const { building_id, mailer_program } = params.row;
        return (
          <div className="w-100 d-flex justify-content-center">
            {isAdmin() ? (
              <MailerProgram
                data={{
                  building_id,
                  active: mailer_program || false,
                }}
                apiCallback={addLeadCompliance}
                programKey={"mailer_program"}
              />
            ) : mailer_program ? (
              <img src={Green} />
            ) : (
              ""
            )}
          </div>
        );
      },
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p>Mailer Program</p>
        </div>
      ),
      minWidth: 100,
      flex: 1,
      // editable: true,
      sortable: false,
      headerClassName: "center-header",
    },
    {
      field: "ll55_enabled",
      headerName: "LL55",
      renderCell: (params) => {
        const { building_id, ll55_enabled } = params.row;
        return (
          <div className="w-100 d-flex justify-content-center">
            {isAdmin() ? (
              <MailerProgram
                data={{
                  building_id,
                  active: ll55_enabled || false,
                }}
                apiCallback={addLL55Compliance}
                programKey={"ll55_enabled"}
              />
            ) : ll55_enabled ? (
              <img src={Green} />
            ) : (
              ""
            )}
          </div>
        );
      },
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p>LL55</p>
        </div>
      ),
      minWidth: 100,
      flex: 1,
      // editable: true,
      sortable: false,
      headerClassName: "center-header",
    },
    {
      field: "fire_notice_active",
      headerName: "Fire Notice Program",
      renderCell: (params) => {
        const { building_id, fire_notice_active } = params.row;
        return (
          <div className="w-100 d-flex justify-content-center">
            {isAdmin() ? (
              <MailerProgram
                data={{
                  building_id,
                  active: fire_notice_active || false,
                }}
                apiCallback={addFireNotice}
                programKey="fire_notice_active"
              />
            ) : fire_notice_active ? (
              <img src={Green} />
            ) : (
              ""
            )}
          </div>
        );
      },
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p>Fire Notice Program</p>
        </div>
      ),
      minWidth: 100,
      flex: 1,
      // editable: true,
      sortable: false,
      headerClassName: "center-header",
    },
    {
      field: "hpd_alert",
      headerName: "HPD alert",
      renderCell: (params) => {
        const { building_id, hpd_alert } = params.row;
        return (
          <div className="w-100 d-flex justify-content-center">
            {isAdmin() ? (
              <HPDalerts
                data={{
                  building_id,
                  active: hpd_alert || false,
                }}
              />
            ) : hpd_alert ? (
              <img src={Green} />
            ) : (
              ""
            )}
          </div>
        );
      },
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p>HPD alert</p>
        </div>
      ),
      minWidth: 100,
      flex: 1,
      // editable: true,
      sortable: false,
      headerClassName: "center-header",
    },
    // {
    //   field: "self_service",
    //   headerName: "Self Service",
    //   renderCell: (params) => {
    //     const { building_id, self_service } = params.row;
    //     return (
    //       <div className="w-100 d-flex justify-content-center">
    //         {isAdmin() ? (
    //           <UpdateSelfService
    //             data={{
    //               building_id,
    //               active: self_service || false,
    //             }}
    //           />
    //         ) : self_service ? (
    //           <img src={Green} />
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    //   renderHeader: (cell) => (
    //     <div className="w-100 d-flex justify-content-center">
    //       <p>Self Service</p>
    //     </div>
    //   ),
    //   minWidth: 100,
    //   flex: 1,
    //   // editable: true,
    //   sortable: false,
    //   headerClassName: "center-header",
    // },
    {
      field: "action",
      headerName: "Action",
      renderCell: (params) => {
        return (
          <div className=" w-100 d-flex justify-content-center">
            <Action params={params} />
          </div>
        );
      },
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p>Action</p>
        </div>
      ),
      minWidth: 100,
      flex: 1,
      // editable: true,
      sortable: false,
      headerClassName: "center-header",
    },
  ];
